/* Source: /app/utils/cn.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(inputs) {
  let args = [].slice.call(arguments);
  return twMerge(clsx(args));
}
export {cn};
//# sourceMappingURL=cn.js.map
